import { PayGoCodeCardPresenter } from "./PayGoCodeCard/PayGoCodeCard";
import PayGoGenericInfo from "./PayGoGenericInfo/PayGoGenericInfo";

const SinglePaygo ={
    Code: PayGoCodeCardPresenter,
    GenericInfo : PayGoGenericInfo
}

export default SinglePaygo;